import { render } from "./creditsList.vue?vue&type=template&id=141b5b96&scoped=true&ts=true"
import script from "./creditsList.vue?vue&type=script&lang=ts"
export * from "./creditsList.vue?vue&type=script&lang=ts"

import "./creditsList.vue?vue&type=style&index=0&id=141b5b96&scoped=true&lang=css"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141b5b96"]])

export default __exports__